export default __webpack_public_path__ + "fonts/iconfont.4e9cb3304c3fe7afd409c23858394d26.ttf";